module.exports = __webpack_public_path__ + "static/media/peacock_dancing.a4480e8f.gif";